import React from "react";
import { Star } from "lucide-react";

const ReviewBadge = ({ compact = false }) => {
  return (
    <div
      className={`inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/5 backdrop-blur ${
        compact ? "px-3 py-1.5" : "px-4 py-2"
      }`}
      data-testid="review-badge"
    >
      <div className="flex items-center gap-0.5 text-[#0055FF]">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} className="w-3.5 h-3.5 fill-current" />
        ))}
      </div>
      <span className={`text-white font-semibold ${compact ? "text-xs" : "text-sm"}`}>5.0</span>
      <span className="w-px h-3 bg-white/20" />
      <span className={`text-white/70 ${compact ? "text-xs" : "text-sm"}`}>2,387 reviews</span>
    </div>
  );
};

export default ReviewBadge;
